import { useContext } from "react";

import { ExportIcon } from "../Icons/Icons";
import { StateContext } from "../../Controllers/context/state";
import { StyledButton } from "../StyledComponents/UserFormStyledComponents";
import supabase from "../../Controllers/utils/supabaseClient";

const ExportToCsv = ({ exportEvents, exportTickers, handleExportData }) => {
    const {
        logError,
        setCardData,
        setLoadingExport,
        setShowExportPopUp,
        setVisibleCards,
        setVisibleEvents,
        sort,
    } = useContext(StateContext);

    const handleExport = async () => {
        if (handleExportData) {
            await handleExportData();

            return;
        }

        if (exportEvents) {
            setVisibleCards({});
            setVisibleEvents(exportEvents);
            setShowExportPopUp(true);

            return;
        }

        if (exportTickers) {
            setVisibleEvents({});
            setVisibleCards({});
            setShowExportPopUp(true);
            setLoadingExport(true);

            try {
                const requestedTickers = typeof exportTickers === 'function' ?
                    await exportTickers() :
                    exportTickers;
                const uniqueTickers = [...new Set((Array.isArray(requestedTickers) ? requestedTickers : []).filter(Boolean))];

                if (!uniqueTickers.length) {
                    return;
                }

                const exportResults = await Promise.allSettled(
                    uniqueTickers.map(async (ticker) => {
                        const res = await supabase.rpc('card_data', {
                            _symbol: ticker,
                            _corr_symbol: sort.correlationAsset || 'SPY',
                        });

                        if (res?.error) {
                            throw new Error(`${ticker}: ${res.error.message}`);
                        }

                        return [ticker, res?.data?.[0]];
                    })
                );

                const fulfilledResults = exportResults.filter(
                    ({ status, value }) => status === 'fulfilled' && value?.[1]
                );
                const rejectedResults = exportResults.filter(
                    ({ status }) => status === 'rejected'
                );

                const nextCardData = fulfilledResults.reduce((acc, { value: [ticker, data] }) => {
                    acc[ticker] = data;

                    return acc;
                }, {});
                const nextVisibleCards = fulfilledResults.reduce((acc, { value: [ticker] }) => {
                    acc[ticker] = ticker;

                    return acc;
                }, {});

                setCardData((prevState) => ({
                    ...prevState,
                    ...nextCardData,
                }));
                setVisibleCards(nextVisibleCards);

                if (rejectedResults.length) {
                    logError(
                        `CSV export skipped ${rejectedResults.length} assets.`,
                        {
                            exportErrors: rejectedResults.map(({ reason }) => reason?.message),
                        },
                        rejectedResults[0]?.reason
                    );
                }

            } catch (error) {
                logError(error.message, undefined, error);
            } finally {
                setLoadingExport(false);
            }

            return;
        }

        setShowExportPopUp(true);
    };

    return (
        <StyledButton style={{ margin: 0, marginLeft: 10 }} onClick={handleExport}>
            Export to CSV
            <ExportIcon />
        </StyledButton>
    )
};

export default ExportToCsv;
